import type { BalticRoute, BalticHistoryPoint } from '@/types/baltic.types';

export const mockBalticRoutes: BalticRoute[] = [
  {
    route: 'TD3C',
    description: 'AG/China',
    decimals: 2,
    tiValue: 110.0,
    tiValueChange: -3.0,
    tiDate: '2025-11-05T00:00:00',
    biValue: 107.0,
    biValueChange: -6.06,
    biDate: '2025-11-05T00:00:00',
    titceScrubber: 103070.65,
    titceVlsfo: 98421.03,
    bitce: 98773,
    sort: 226,
  },
  {
    route: 'TD2',
    description: 'AG/Singapore',
    decimals: 2,
    tiValue: 114.33,
    tiValueChange: 1.0,
    tiDate: '2025-11-05T00:00:00',
    biValue: 112.89,
    biValueChange: -8.89,
    biDate: '2025-11-05T00:00:00',
    titceScrubber: 106268.08,
    titceVlsfo: 101486.87,
    bitce: 105572,
    sort: 227,
  },
  {
    route: 'TD15',
    description: 'WAF/CHINA (from Loop)',
    decimals: 2,
    tiValue: 106.0,
    tiValueChange: -4.0,
    tiDate: '2025-11-05T00:00:00',
    biValue: 106.5,
    biValueChange: -3.25,
    biDate: '2025-11-05T00:00:00',
    titceScrubber: 98432.5,
    titceVlsfo: 92834.21,
    bitce: 94820,
    sort: 228,
  },
  {
    route: 'TD22',
    description: 'USG/China',
    decimals: 0,
    tiValue: 13200000.0,
    tiValueChange: 0.0,
    tiDate: '2025-11-05T00:00:00',
    biValue: 13242222.0,
    biValueChange: -163334.0,
    biDate: '2025-11-05T00:00:00',
    titceScrubber: 13100000.0,
    titceVlsfo: 12950000.0,
    bitce: 13050000,
    sort: 229,
  },
];

export const mockBalticHistory: BalticHistoryPoint[] = [
  {
    date: '2025-10-21T00:00:00',
    biValue: 92.5,
    tiValue: 90.8,
    tiScrubber: 85432.1,
    tivlsfo: 82145.3,
    bitrtce: 84320,
  },
  {
    date: '2025-10-22T00:00:00',
    biValue: 84.2,
    tiValue: 82.9,
    tiScrubber: 78521.4,
    tivlsfo: 75823.7,
    bitrtce: 76892,
  },
  {
    date: '2025-10-23T00:00:00',
    biValue: 84.8,
    tiValue: 83.4,
    tiScrubber: 79124.6,
    tivlsfo: 76234.8,
    bitrtce: 77456,
  },
  {
    date: '2025-10-24T00:00:00',
    biValue: 91.2,
    tiValue: 89.7,
    tiScrubber: 84329.2,
    tivlsfo: 81456.9,
    bitrtce: 82789,
  },
  {
    date: '2025-10-27T00:00:00',
    biValue: 91.8,
    tiValue: 90.1,
    tiScrubber: 84892.3,
    tivlsfo: 81987.4,
    bitrtce: 83124,
  },
  {
    date: '2025-10-28T00:00:00',
    biValue: 97.2,
    tiValue: 95.6,
    tiScrubber: 89234.7,
    tivlsfo: 86543.2,
    bitrtce: 87698,
  },
  {
    date: '2025-10-29T00:00:00',
    biValue: 127.5,
    tiValue: 125.8,
    tiScrubber: 118456.3,
    tivlsfo: 114789.6,
    bitrtce: 116234,
  },
  {
    date: '2025-10-30T00:00:00',
    biValue: 126.8,
    tiValue: 125.2,
    tiScrubber: 117892.1,
    tivlsfo: 114234.5,
    bitrtce: 115567,
  },
  {
    date: '2025-10-31T00:00:00',
    biValue: 125.3,
    tiValue: 123.9,
    tiScrubber: 116543.8,
    tivlsfo: 112987.3,
    bitrtce: 114321,
  },
  {
    date: '2025-11-03T00:00:00',
    biValue: 124.1,
    tiValue: 122.7,
    tiScrubber: 115432.6,
    tivlsfo: 111897.4,
    bitrtce: 113234,
  },
  {
    date: '2025-11-04T00:00:00',
    biValue: 113.06,
    tiValue: 113.0,
    tiScrubber: 106268.08,
    tivlsfo: 101486.87,
    bitrtce: 105572,
  },
  {
    date: '2025-11-05T00:00:00',
    biValue: 107.0,
    tiValue: 110.0,
    tiScrubber: 103070.65,
    tivlsfo: 98421.03,
    bitrtce: 98773,
  },
];
